import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { OnboardingStepperComponent } from './components/onboarding-stepper/onboarding-stepper.component';
import { OnboardingComponent } from './containers/onboarding/onboarding.component';
import { OnboardingRoutingModule } from './onboarding-routing.module';
import { NickComponent } from './components/nick/nick.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TileButtonsListComponent } from '../shared/components/tile-buttons-list/tile-buttons-list.component';

// const swiperConfig: SwiperConfigInterface = {
//   direction: 'horizontal',
//   slidesPerView: 1,
// };

@NgModule({
  declarations: [
    OnboardingComponent,
    OnboardingStepperComponent,
    NickComponent,
  ],
  exports: [OnboardingComponent, OnboardingStepperComponent],
  imports: [CommonModule, OnboardingRoutingModule, SharedModule, ReactiveFormsModule, TileButtonsListComponent],
  providers: [
    // {
    //   provide: SWIPER_CONFIG,
    //   useValue: swiperConfig,
    // },
  ],
})
export class OnboardingModule {}
